import { useState } from "react";
import {
  getAllRoles,
  getRoleById,
  deleteRole,
  newRole,
  updateRole,
} from "../services/roles.service";

const INITIAL_SUCCESS_ERROR = {
  getAllRoles: "",
  getRoleById: "",
  create: "",
  update: "",
  deleteRole: "",
};

export const useRoles = ({ spinner }) => {
  const [rolesList, setRolesList] = useState([]);
  const [role, setRole] = useState({});
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);

  const getRoles = async (params) => {
    clearAlerts();
    spinner(true);

    const response = await getAllRoles(params);
    if (response.error) {
      spinner(false);
      setRolesList([]);
      setError({ getAllChairPerson: response.error });
    } else {
      spinner(false);

      setRolesList(response.data);
    }
  };

  const getRole = async (id) => {
    clearAlerts();
    const response = await getRoleById(id);
    spinner(true);

    if (response.error) {
      setRole({});
      setError({ getRoleById: response.error });
    } else {
      spinner(false);

      setRole(response.data);
    }
  };

  const setDeleteRole = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await deleteRole(params);
    spinner(false);
    if (response.error) {
      setRolesList([]);
      setError({ deleteRole: response.error });
    } else {
      setSuccess({ delete: "delete" });
      setRolesList(response.data);
    }
  };

  const create = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await newRole(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };

  const update = async (id, request) => {
    clearAlerts();
    spinner(true);
    const response = await updateRole(id, request);
    spinner(false);
    if (response.error) {
      setError({ update: response.error });
    } else {
      setSuccess({ update: "update" });
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.name,
        description: item.description
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  return {
    getRoles,
    sanitizeForTable,
    getRole,
    rolesList,
    role,
    success,
    error,
    setDeleteRole,
    create,
    update,
  };
};
